import React, { useState } from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { ChevronDown } from "lucide-react";
import { COUNTRY_CODES } from "./countryCodes";

export { COUNTRY_CODES };

const PhoneInput = ({ label, id, code, number, onCodeChange, onNumberChange, required = false, placeholder = "555 000 00 00" }) => {
  const [open, setOpen] = useState(false);
  const selected = COUNTRY_CODES.find((c) => c.code === (code || "+1")) || COUNTRY_CODES[0];

  return (
    <div>
      {label && <Label htmlFor={id} className="text-[13px] text-[var(--ri-ink-soft)]">{label}</Label>}
      <div className="mt-1 flex gap-2">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <button
              type="button"
              aria-label="Country code"
              className="px-3 h-11 border border-[var(--ri-border)] rounded-md bg-white text-[15px] min-w-[120px] flex items-center gap-1.5 focus:outline-none focus:ring-2 focus:ring-[var(--ri-red)]/30"
            >
              <span>{selected.flag}</span>
              <span>{selected.code}</span>
              <ChevronDown size={14} className="ml-auto text-[var(--ri-muted)]" />
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-[280px] p-0" align="start">
            <Command
              filter={(value, search) => {
                const item = COUNTRY_CODES.find((c) => `${c.name}-${c.code}` === value);
                if (!item) return 0;
                const q = search.toLowerCase();
                return item.name.toLowerCase().includes(q) || item.code.includes(q) ? 1 : 0;
              }}
            >
              <CommandInput placeholder="Search country or code..." />
              <CommandList>
                <CommandEmpty>No country found.</CommandEmpty>
                <CommandGroup>
                  {COUNTRY_CODES.map((c) => (
                    <CommandItem
                      key={c.code + c.name}
                      value={`${c.name}-${c.code}`}
                      onSelect={() => {
                        onCodeChange(c.code);
                        setOpen(false);
                      }}
                      className="cursor-pointer"
                    >
                      <span className="mr-2">{c.flag}</span>
                      <span className="flex-1">{c.name}</span>
                      <span className="text-[var(--ri-muted)]">{c.code}</span>
                    </CommandItem>
                  ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
        <Input
          id={id}
          type="tel"
          required={required}
          value={number || ""}
          onChange={(e) => onNumberChange(e.target.value)}
          placeholder={placeholder}
          className="flex-1 h-11 text-[15px]"
        />
      </div>
    </div>
  );
};

export default PhoneInput;
